import { z } from "zod";
import { ZMigrationRunMongoDocument } from "./mongodocuments/migrationRunMongoDocument.schema";
export const ZMigrationTarget = z.object({ databaseName: z.string(), hosts: z.string() });
export const ZMigrationList = z.object({
    target: ZMigrationTarget,
    locked: z.boolean(),
    migrations: z.array(z.object({
        id: z.string(), description: z.string(),
        latestRun: ZMigrationRunMongoDocument.nullable(),
    })),
});
export const ZRunMigrationInput = z.object({
    migrationId: z.string(),
    confirmDatabaseName: z.string(),
    confirmHosts: z.string(),
    allowRerun: z.boolean().default(false),
});
